var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmptyTravelPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmptyTravelPlan@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.3551488,23.0252422 C54.2101157,21.9399649 54.7177316,20.4929286 55.5154138,19.6970586 L58.1985268,17.164745 L65.0876005,10.7254333 C65.1601171,10.6530815 65.2326337,10.5807297 65.3051502,10.5083779 C67.3356141,8.33782336 68.1332963,3.63495527 65.6677331,1.31969714 C63.2746864,-0.995560999 58.5611096,0.017364436 56.5306458,2.18791894 L47.5385916,11.8830624 C46.813426,12.6789324 45.2905781,13.1853951 44.2028296,13.0406915 L6.20414912,7.6143052 C5.11640064,7.46960156 3.66606932,8.0484161 3.01342023,8.84428608 L0.402823862,12.027766 C-0.322341796,12.8959878 -0.0322755326,13.8365614 0.982956388,14.2706723 L31.8750134,25.9916667 C32.8902453,26.3534257 33.107795,27.3663512 32.3826294,28.1622212 L19.1120978,42.2708254 C18.9670647,42.3431772 18.749515,42.3431772 18.6044819,42.3431772 L3.73858589,42.4878809 C3.15845336,42.4878809 2.6508374,42.9219918 2.57832084,43.5008063 L1.85315518,47.190749 C1.78063861,47.6972117 2.07070487,48.348378 2.57832084,48.4930817 L13.4558057,52.5447834 C13.9634217,52.7618389 14.5435542,53.3406534 14.6885873,53.8471161 L18.749515,64.6998886 C18.9670647,65.2063513 19.5471972,65.5681104 20.0548132,65.4234068 L23.753158,64.6998886 C24.260774,64.6275368 24.6958734,64.0487223 24.76839,63.5422596 L24.9134231,48.6377853 C24.9134231,48.4930817 24.9134231,48.348378 24.9859397,48.1313226 L32.9627619,40.6790855 L39.1991866,34.8185883 C39.9968688,34.0950701 40.9395841,34.3121256 41.3746835,35.325051 L53.1223672,66.2192768 C53.48495,67.2322022 54.5001819,67.5216095 55.3703807,66.7980913 L58.5611096,64.1934259 C59.3587918,63.5422596 59.9389244,62.0952232 59.7938912,61.009946 L54.3551488,23.0252422 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel-plans_Empty-state",
    transform: "translate(-154.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/MainMenu/Travel_Filled",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(8.400000, 8.400000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.400000, -8.400000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 84 0 84 84 0 84"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyTravelPlan);
export default __webpack_public_path__ + "static/media/icEmptyTravelPlan.21abdf9f1ebf850299abddb4a5ed3a9d.svg";
export { ForwardRef as ReactComponent };